import { useMemo } from "react";
import { useExperiment } from "@hopper-b2b/experiments";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getDarkModePreferred } from "@hopper-b2b/themes";
import { ActionLink, ChoiceButton } from "@hopper-b2b/ui";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import { FEATURE_FLAGS } from "../../../App";
import Edit from "../../../assets/client/edit.svg";
import "./styles.scss";

export interface ITravelerSelectRowProps {
  className?: string;
  value: string;
  selectRowType: string;
  isSelected: boolean;
  onClickEdit: () => void;
  onClickSelect?: () => void;
  buttonClassName?: string;
  disabled?: boolean;
  isMobile?: boolean;
}

export const TravelerSelectRow = ({
  className,
  value,
  selectRowType,
  isSelected,
  onClickEdit,
  onClickSelect,
  buttonClassName,
  disabled,
  isMobile,
}: ITravelerSelectRowProps): JSX.Element => {
  const { t, language } = useI18nContext();
  const enableDarkMode = useExperiment(FEATURE_FLAGS.APP_DARKMODE);
  const darkModePreferred = getDarkModePreferred();

  const travelerTypeEdit = useMemo(() => {
    return selectRowType === "phoneNumber"
      ? t("phone")
      : selectRowType === "email"
        ? t("email")
        : selectRowType;
  }, [selectRowType, t]);

  return (
    <div
      className={clsx("traveler-select-row-root", "uber", className, {
        disabled,
        mobile: isMobile,
      })}
    >
      <div
        className={clsx("traveler-select-row-container", {
          selected: isSelected,
        })}
      >
        <div className="traveler-select-row-description">
          <Typography variant="body1" className="type" data-dd-privacy="mask">
            {travelerTypeEdit}
          </Typography>
          <Typography variant="h6" className="name" data-dd-privacy="mask">
            {value}
          </Typography>
        </div>
        <div className="traveler-select-row-buttons-section">
          <ActionLink
            className="edit-button"
            disabled={disabled}
            onClick={onClickEdit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onClickEdit();
              }
            }}
            label={t("editTraveler")}
            content={<img src={Edit} alt={t("edit")} />}
          />
          <ChoiceButton
            onClick={onClickSelect}
            isChosen={isSelected}
            disabled={!!disabled}
            ariaLabel={`${t("choose")} ${value}`}
            message={t("choose")}
            className={`${buttonClassName} ${language} ${
              enableDarkMode && darkModePreferred ? "dark-mode" : ""
            }`}
          />
        </div>
      </div>
    </div>
  );
};
